import { DatePipe, DecimalPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CardModule } from 'primeng/card';
import { DividerModule } from 'primeng/divider';
import { ProgressBarModule } from 'primeng/progressbar';

@Component({
  selector: 'cosmos-strength-insights-card',
  imports: [TranslatePipe, DecimalPipe, DatePipe, NgClass,
    DividerModule, CardModule, ProgressBarModule,
  ],
  templateUrl: './stength-insights-card.component.html',
  styleUrls: ['./stength-insights-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StrengthInsightsCardComponent {
  readonly currentMaturity = input<number | undefined>(undefined);
  readonly specifications_maturity = input<number[] | undefined>(undefined);
  readonly currentRelativeMaturity = input<number | undefined>(undefined);
  readonly specifications_relative_maturity = input<number[] | undefined>(undefined);
  readonly specifications = input<number[] | undefined>(undefined);
  readonly currentStrength = input<number>(0);
  readonly currentTime = input<any>(null);
  readonly config = input<any>(null);

  getNextStrengthCheckpoint(strength: number) {
    for (const checkpoint of this.specifications() ?? []) {
      if (strength < checkpoint) {
        const specs = this.specifications()!;
        return 100 * checkpoint / specs[specs.length - 1];
      }
    }
    return 100;
  }

  getNextMaturityCheckpoint(maturity: number) {
    for (const checkpoint of this.specifications_maturity() ?? []) {
      if (maturity < checkpoint) {
        const specs = this.specifications_maturity()!;
        return 100 * checkpoint / specs[specs.length - 1];
      }
    }
    return 100;
  }

  getNextRelativeMaturityCheckpoint(relative_maturity: number) {
    for (const checkpoint of this.specifications_relative_maturity() ?? []) {
      if (relative_maturity < checkpoint) {
        const specs = this.specifications_relative_maturity()!;
        return 100 * checkpoint / specs[specs.length - 1];
      }
    }
    return 100;
  }
}
